import type {
  TRow,
  TRowsToColumnsResult,
} from '../types/innerLayout/excel-file-parser';

export const rowsToColumns = (rows: TRow[]) => {
  const result: TRowsToColumnsResult = {
    values: {},
    valuesWithMeta: {},
  };

  rows.forEach((row) => {
    const { __rowNum__, ...data } = row;

    for (const key in data) {
      if (!result.values[key]) {
        result.values[key] = [];
        result.valuesWithMeta[key] = [];
      }

      let value = data[key];

      // Convert numeric strings back to numbers, but preserve phone numbers starting with +
      if (typeof value === 'string' && !value.startsWith('+') && !isNaN(Number(value)) && value.trim() !== '') {
        value = Number(value);
      }

      result.values[key].push(value);

      // Append the value along with its row number to the corresponding column array
      result.valuesWithMeta[key].push({
        value,
        rowKey: __rowNum__,
      });
    }
  });

  return result;
};

export const parseExcelFile = async (file: File) => {
  if (!file) return;

  const XLSX = await import('xlsx');

  const buffer = await file.arrayBuffer();
  const isCSV = file.name.toLowerCase().endsWith('.csv');

  const workbook = XLSX.read(buffer, {
    type: 'array',
    ...(isCSV && { raw: true, cellText: false })
  });

  if (!workbook.SheetNames.length) {
    return null;
  }

  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  const rows = XLSX.utils.sheet_to_json<TRow>(sheet, {
    defval: '',
    ...(isCSV && { raw: true })
  });

  const columns = rowsToColumns(rows);

  return columns;
};
